const INCLUDE_PROPERTIES =
    'PartDetails,AttributeDeviceValues,DeviceType,Customer,UsageType,DeviceGroup,DeviceModel,DeviceSKU,' +
    'PartDetails.PartCategory,PartDetails.PartGroup,PartDetails.PartSKU,PartDetails.PartType,' +
    'PartDetails.UsageType,' +
    'Assignee,' +
    'Customer.LeadTechnician';

export const DEVICE_PARAMS = {
    includeProperties: INCLUDE_PROPERTIES,
};
